import { gql } from "@apollo/client";

// Only the saved versions of what the track editor shows: cheap to ask on
// every return to the page, so the whole track is fetched again only when one
// changed.
export default gql`
  query getCareerTrackVersions(
    $careerTrackId: Int!
    $organizationId: Int!
    $userId: Int!
    $withPerson: Boolean!
  ) {
    careerTrack(id: $careerTrackId) {
      id
      version
    }
    userCareerCriteriaVersion(organizationId: $organizationId, userId: $userId)
      @include(if: $withPerson)
    # Competencies belong to the organization, not the track. One deleted
    # elsewhere drops out of this list. One attached or detached, or whose
    # shared criteria changed, gets a new version.
    competencies(organizationId: $organizationId) {
      edges {
        node {
          id
          version
        }
      }
    }
  }
`;
